<template>
    <div class="">
        <div class="crumbs-navigate">
            <div class="wrapper">
                <div class="crumbs-navigate-text">
                    <!-- <ct-button class="init-button" @click="goRoute('/quiz')">
                        <ct-icon name="list" class="list-icon"></ct-icon>
                    </ct-button> -->
                    <span>{{ $t(sectiontext) }}</span>
                    <ct-icon name="mianbao" class="erji-icon"></ct-icon>
                    <span>{{ examTitle }}</span>
                    <span style="float: right" v-if="startTime && !examSubmitted && !isMobile">
                    {{ examTime }}
                    </span>
                </div>
                <div class="score-area_mobile" v-if="isMobile">
                    <span v-if="startTime && !examSubmitted">{{ examTime }}</span>
                    <div v-if="examSubmitted" class="score">
                        <span>{{ $t('question.FullMarks') }}: {{ totalScore }}</span>
                        <span>{{ $t('question.YourScore') }}: {{ myScore }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-content-container">
            <transition name="fadeInUp">
              <SubContent
                :questionList="questionList"
                :myScore="myScore"
                :isPublishAnswer="isPublishAnswer"
                :examInfo="examInfo"
                @set-breakpoint-record="setBreakpointRecord">
              </SubContent>
            </transition>
        </div>
         <improve-info
            :visible="improveInfoVisible"
            :formInfo="improveForm"
            @close="improveInfoModalClose"
            @success="improveSuccess"></improve-info>
    </div>
</template>
<script>
// 1、进入答题页面，调用考试信息接口，获取登录状态，报名课程状态，考试开始时间，答题状态
// 2、判断答题状态，分为未完成样式和已完成样式
// 4、调用题目列表接口，根据题目调题目详情接口
// 3、未完成答题展示考试时长，交卷按钮，已完成不展示
import api from '../../api'
import { vueAppPassportDomin, vueAppDomin } from '@ca/constants/variables'
import SubContent from './component/SubContent.vue'
import cookie from '@/utils/cookie'
import { mapGetters, mapActions } from 'vuex'
import { GRADE } from '@/constants'
import ImproveInfo from '@/components/improve-info/index.vue'

export default {
  name: 'Answer',
  components: {
    SubContent,
    ImproveInfo
  },
  data () {
    return {
      examTitle: '',
      sectiontext: 'nav.Homework',
      startTime: 0,
      timer: null,
      examTime: '',
      improveInfoVisible: false,
      improveForm: {
        // email: '',
        // mobile: '',
        school: '',
        grade: '',
        // 英文名
        nickname: '',
        // 中文名
        username: '',
        signature: ''
      },
      //   improveLoading: false,
      profile: {},
      myScore: 0,
      totalScore: 0,
      examInfo: {},
      questionList: [],
      isPublishAnswer: 0,
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    ...mapGetters('answer', ['examSubmitted']),
    gradeList () {
      return JSON.parse(JSON.stringify(GRADE)).map(item => {
        return {
          tag: item.label,
          value: item.value

        }
      })
    }
  },
  created () {
    api.getUserInfo().then(res => {
      if (res.data.code === 1) {
        this.profile = res.data.data || {}
        if (this.checkUserInfo()) {
          this.getQuestionList()
          this.getExamInfo()
        } else {
          this.improveForm = {
            // email: '',
            // mobile: '',
            school: this.profile.school,
            grade: this.profile.grade,
            // 英文名
            nickname: this.profile.nickname,
            // 中文名
            username: this.profile.username,
            signature: this.profile.signature
          }
          this.improveInfoVisible = true
        }
      } else if (res.data.code === 100000) {
        // 跳转登录页面
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
      } else {
        this.$toast({
          type: 'error',
          message: res.data.error
        })
      }
    })
  },
  methods: {
    ...mapActions('answer', ['updateExamSubmitStatus', 'updateQuestionIndex', 'updateExamPublishStatus']),
    // 完善信息面板关闭
    improveInfoModalClose () {
      this.improveInfoVisible = false
      //   this.modalValiStatus = true
      this.improveForm = {
        // email: '',
        // mobile: '',
        school: '',
        grade: '',
        // 英文名
        nickname: '',
        // 中文名
        username: '',
        signature: ''
      }
      this.$refs['improveForm'].resetFields()
    },
    improveSuccess () {
      this.$toast({ type: 'success', message: 'successfully updated.' })
      setTimeout(() => {
        window.location.reload()
        this.improveInfoVisible = false
      }, 3000)
    },
    checkUserInfo () {
      if (!this.profile.school || !this.profile.grade || !this.profile.username || !this.profile.nickname) {
        return false
      } else {
        return true
      }
    },
    getExamInfo () {
      api.getExamInfo({
        params: {
          work_id: +this.$route.params.exam_id,
          class_id: +this.$route.params.class_id,
          subclass_id: +this.$route.params.subclass_id
        }
      }).then(({ data }) => {
        if (data.code === 1) {
          this.examInfo = data.data
          this.examTitle = data.data.title || ''
          this.myScore = data.data.mark || 0
          this.isPublishAnswer = data.data.publish_answer
          this.updateExamPublishStatus(!!data.data.publish_answer)
          this.updateExamSubmitStatus(data.data.submitted)
          // 判断是否开始考试
          if (data.data.start_at) {
            this.startTime = data.data.start_at
            this.startTimeing()
          } else {
            // 触发开始考试
            this.handleStartExam(data.data.current_time)
          }
        } else if (data.code === 100000) {
          // 跳转登录页面
          window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        } else {
          this.questionList = []
          this.$toast({ type: 'warning', message: data.error })
          setTimeout(() => {
            window.location.href = vueAppDomin + '/live/' + this.$route.params.class_id
          }, 3000)
        }
      })
    },
    setBreakpointRecord (data) {
      const domain = window.location.host.split(':')[0].split('.').splice(1).join('.')
      cookie.setCookie('quiz_breakpoint', JSON.stringify(data), '30', '.' + domain)
    },
    formatTimer (distance) {
      // 计算剩余的天、小时、分钟和秒
    //   var days = Math.floor(distance / (1000 * 60 * 60 * 24))
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = Math.floor((distance % (1000 * 60)) / 1000)
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      this.examTime = `${hours} : ${minutes} : ${seconds}`
    },
    startTimeing () {
      // 获取当前时间
      var now = new Date().getTime()
      var distance = now - (this.startTime * 1000)
      this.timer = setInterval(() => {
        this.formatTimer(distance)
        distance += 1000
      }, 1000)
    },
    handleStartExam (currentTime) {
      api.startExam({
        params: {
          work_id: +this.$route.params.exam_id,
          class_id: +this.$route.params.class_id,
          subclass_id: +this.$route.params.subclass_id
        }
      }).then(res => {
        this.startTime = currentTime
        this.getQuestionList()
        setTimeout(() => {
          this.startTimeing()
        }, 1000)
      })
    },
    // 获取题目列表
    getQuestionList () {
      api.getExamQuestionList({
        params: {
          work_id: +this.$route.params.exam_id,
          class_id: +this.$route.params.class_id,
          subclass_id: +this.$route.params.subclass_id
        }
      }).then((res) => {
        if (res.data.code === 1) {
          this.questionList = [...res.data.data || []]
          this.totalScore = 0
          this.questionList.forEach(item => {
            this.totalScore += item.mark
          })
        } else {
          this.$toast({
            type: 'error',
            message: res.data.error,
            duration: 3000
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
$navigate-height: 76px;
$mianbao-height: 46px;
// /deep/ .my-select {
//     width: 200px;
//     .ct-select-input {
//         line-height: 48px;
//         border: 1px solid rgba(26,61,94,.16);
//         padding: 0 24px;
//         &::placeholder {
//           color: rgba(118,139,158,1);
//           font-size: 14px;
//         }
//     }
// }
.crumbs-navigate {
    position: fixed;
    z-index: 1000;
    width: 100%;
    top: $navigate-height;
    background: #fff;
    box-shadow: 0px 2px 14px 0px rgba(79, 117, 162, 0.07);
    font-size: 14px;
    font-family: SFProDisplay-Regular;
    font-weight: 400;
    color: rgba(186, 196, 206, 1);
    line-height: 14px;

    &-text {
        font-size: 14px;
        font-family: SFProDisplay-Regular;
        font-weight: 400;
        color: #BAC4CE;
        padding: 12px 0;
        line-height: 14px;
    }

    .init-button {
        padding: 0;
        width: auto;
        min-width: auto;
        height: auto;
    }

    .list-icon {
        margin-right: 8px;
        color: #1A3D5E;
        cursor: pointer;
        font-size: 20px;
        vertical-align: middle;
    }

    .erji-icon {
        vertical-align: middle;
        margin: 0 14px;
    }

    .switcher-container {
        height: 32px;
        position: absolute;
        line-height: 32px;
        right: 0;
        top: 7px;
    }
}

.wrapper {
    position: relative;
}

.sub-content-container {
    margin-top: $mianbao-height + 48;
}
.score-area_mobile {
    height: 40px;
    line-height: 40px;
    text-align: center;
    .score {
        width: 100%;
        span {
            margin-left: 20px;
        }
    }
}
</style>
